import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import BlogCard from '../components/blog/BlogCard';
import BlogSearch from '../components/blog/BlogSearch';
import { BlogPost, BlogSearchParams } from '../types/BlogTypes';
import { searchBlogPosts } from '../utils/blogUtils';
import '../assets/styles/Blog.css';

const BlogListPage: React.FC = () => {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const loadPosts = async () => {
      setLoading(true);
      
      // Parse search parameters
      const searchParams = new URLSearchParams(location.search);
      const params: BlogSearchParams = {
        query: searchParams.get('query') || undefined,
        tag: searchParams.get('tag') || undefined
      };
      
      // Search posts based on the parameters
      const searchResults = await searchBlogPosts(params);
      setPosts(searchResults);
      setLoading(false);
    };
    
    loadPosts();
  }, [location.search]);

  // SEO metadata
  const pageTitle = posts.length > 0 
    ? "Blog | Price on Rails | Trading Insights"
    : "Blog | Price on Rails | No Results Found";
  
  const pageDescription = "Explore the latest trading insights, strategies, and updates from the Price on Rails team. Learn to leverage AI-powered trading tools effectively.";

  return (
    <div className="blog-container">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
      </Helmet>

      <h1 className="blog-title">Price on Rails Blog</h1>
      
      <BlogSearch />
      
      {loading ? (
        <div className="blog-loading">Loading blog posts...</div>
      ) : posts.length > 0 ? (
        <div className="blog-list">
          {posts.map(post => (
            <BlogCard key={post.id} post={post} />
          ))}
        </div>
      ) : (
        <div className="blog-no-results">
          <h3>No blog posts found</h3>
          <p>Try adjusting your search criteria or browse all posts.</p>
        </div>
      )}
    </div>
  );
};

export default BlogListPage; 